import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import Paper from "@mui/material/Paper";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { hmLightTheme } from "../../../themes/hmTheme";
import CustomTable from "../../../unit/CustomTable";
import formatCurrency from "../../../unit/formatCurrency";
import HeaderLabelTitle from "../../../unit/HeaderLabelTitle";
import HtmlTip from "../../../unit/HtmlTip";
import GetCreditorUnparsedValue from "./GetCreditorUnparsedValue";
interface LineOfCreditProps {
  sourcedata: {
    tradeData: {
      lineOfCredit: any[];
    };
    account_type_code: { [key: string]: string };
    MOP_code: { [key: string]: string };
  };
}

const LineOfCredit = ({ sourcedata }: LineOfCreditProps) => {
  const data = sourcedata?.tradeData?.lineOfCredit;
  if (data == null || data == undefined) {
    return null;
  }
  const account_type_code = sourcedata?.account_type_code;
  const MOP_code = sourcedata?.MOP_code;

  const account_type_title = (account: any) => {
    if (account == "" || account == undefined) {
      return "";
    }
    let accounttitle = "";
    for (const key in account) {
      for (const type in account[key].type) {
        accounttitle = account[key].type[type];
      }
    }

    if (accounttitle && account_type_code[accounttitle]) {
      accounttitle = account_type_code[accounttitle];
    }
    return accounttitle;
  };

  const account_status = (accountRating: any) => {
    if (accountRating == "" || accountRating == undefined) {
      return "";
    }
    let accountstatus = "";

    if (accountRating && MOP_code[accountRating]) {
      accountstatus = MOP_code[accountRating];
    }
    return accountstatus;
  };

  const collectionNote = (dateClosed: any, closedIndicator: any) => {
    if (dateClosed == "" || dateClosed == undefined) {
      return "";
    }
    let note = "";
    if (dateClosed && dateClosed.content) {
      if (Date.parse(dateClosed.content) < Date.now()) {
        note = closedIndicator ? closedIndicator : "";
      } else {
        note = "Open";
      }
    }
    return note;
  };

  const paymentHistory = (history: any) => {
    if (history == "" || history == undefined) {
      return "";
    }
    let paymentText = "";
    let paymentTextArr = [];
    let paymentMessage = "";
    let paymentPop = "";
    let startDate = "";
    for (const key in history) {
      if (history[key].paymentPattern) {
        for (const val in history[key].paymentPattern) {
          paymentText += history[key].paymentPattern[val].text;
          startDate = history[key].paymentPattern[val].startDate.content;
        }
        break;
      }
    }
    if (paymentText) {
      paymentTextArr = paymentText.split("");
      let paymentCount = 0;
      for (const key in paymentTextArr) {
        if (paymentTextArr[key] == "1") {
          paymentPop += '<span style="color:green;">1</span>';
        } else {
          paymentPop += '<span style="color:red;">0</span>';
        }
      }
    }
    paymentMessage = paymentTextArr.length + " Months Ending " + startDate;

    return (
      <HtmlTip title={paymentPop} sx={{ backgroundColor: "White" }}>
        <Typography
          variant="body2"
          sx={{ color: "#00ccb1", cursor: "pointer" }}
        >
          {paymentMessage}
        </Typography>
      </HtmlTip>
    );
  };

  const ontimePayment = (history: any) => {
    if (history == "" || history == undefined) {
      return "";
    }
    let paymentText = "";
    let paymentOntime = "";
    for (const key in history) {
      if (history[key].paymentPattern) {
        for (const val in history[key].paymentPattern) {
          paymentText += history[key].paymentPattern[val].text;
        }
        break;
      }
    }
    if (paymentText) {
      let paymentTextArr = paymentText.split("");
      let paymentCount = 0;
      for (const key in paymentTextArr) {
        if (paymentTextArr[key] == "1") {
          paymentCount++;
        }
      }
      paymentOntime =
        ((paymentCount / paymentTextArr.length) * 100).toFixed(2) + "%";
    }
    return paymentOntime;
  };

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <HeaderLabelTitle
          title={
            `Line Of Credit ( <span style="color: #1976d2;">` +
            data?.length +
            `</span> Records )`
          }
          suffix=""
        />
      </AccordionSummary>
      <AccordionDetails
        sx={{
          maxWidth: "100%",
          overflowX: "auto",
        }}
      >
        <TableContainer
          component={Paper}
          sx={{
            maxWidth: "100%",
            width: "100%",
            wordBreak: "break-word",
            // overflowX: "hidden",
            overflow: "auto",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            borderRadius: 0,
            "& .MuiTableRow-head": {
              border: "none",
            },
          }}
        >
          <CustomTable
            sx={{ minWidth: 650 }}
            size="small"
            aria-label="Revolving"
          >
            <TableHead>
              <TableRow>
                <TableCell>Date Closed</TableCell>
                <TableCell>Creditor</TableCell>
                <TableCell>Liability Ownership</TableCell>
                <TableCell>Date Opened</TableCell>
                <TableCell>Credit Limit</TableCell>
                <TableCell>Historical Max Balance</TableCell>
                <TableCell>Current Balance</TableCell>
                <TableCell>Monthly Payment Amount</TableCell>
                <TableCell>Account Status</TableCell>
                <TableCell>Past Due Amount</TableCell>
                <TableCell>Payment History</TableCell>
                <TableCell>On-Time Payment</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
                  >
                    {row.dateClosed ? row.dateClosed.content : ""}
                  </TableCell>
                  <TableCell>
                    {GetCreditorUnparsedValue(row.subscriber)}
                  </TableCell>
                  <TableCell>
                    {row.ECOADesignator ? row.ECOADesignator : ""}
                  </TableCell>
                  <TableCell>
                    {/* {account_type_title(row.account)} */}
                    {row.dateOpened && row.dateOpened.content
                      ? row.dateOpened.content
                      : ""}
                  </TableCell>
                  <TableCell>
                    {/* {row.portfolioType ? row.portfolioType : ""} */}
                    {row.creditLimit ? formatCurrency(row.creditLimit) : ""}
                  </TableCell>
                  <TableCell
                    sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
                  >
                    {row.highCredit ? formatCurrency(row.highCredit) : ""}
                  </TableCell>
                  <TableCell
                    sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
                  >
                    {row.currentBalance
                      ? formatCurrency(row.currentBalance)
                      : ""}
                  </TableCell>
                  <TableCell
                    sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
                  >
                    {Array.isArray(row.terms) &&
                    row.terms.length > 0 &&
                    row.terms[0].scheduledMonthlyPayment
                      ? formatCurrency(row.terms[0].scheduledMonthlyPayment)
                      : ""}
                  </TableCell>
                  <TableCell
                    sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
                  >
                    {account_status(row.accountRating)}
                  </TableCell>
                  <TableCell>{formatCurrency(row.pastDue)}</TableCell>
                  <TableCell
                    sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
                  >
                    {paymentHistory(row.paymentHistory)}
                  </TableCell>
                  <TableCell
                    sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
                  >
                    {ontimePayment(row.paymentHistory)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </CustomTable>
        </TableContainer>
      </AccordionDetails>
    </Accordion>
  );
};

export default LineOfCredit;
